import { render } from "./balanceData.html?vue&type=template&id=b8b97ea8&scoped=true&ts=true"
import script from "./balanceData.ts?vue&type=script&lang=ts"
export * from "./balanceData.ts?vue&type=script&lang=ts"

import "./balanceData.scss?vue&type=style&index=0&id=b8b97ea8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b97ea8"]])

export default __exports__